import { render } from "./BtnLike.vue?vue&type=template&id=029b9690&scoped=true"
import script from "./BtnLike.vue?vue&type=script&lang=js"
export * from "./BtnLike.vue?vue&type=script&lang=js"

import "./BtnLike.vue?vue&type=style&index=0&id=029b9690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029b9690"]])

export default __exports__